export * from './hooks';
export * from './fetcher';
export * from './status';
export * from './spot-faults';
export { useReportedDroneOsdGimbalPayloadIndex } from './drone-osd.ts';
export { useReportedDroneOsdGimbal } from './drone-osd.ts';
export { useDockOSDOverview } from './drone-osd.ts';
export { useReportedDockOSD } from './drone-osd.ts';
export { useReportedDroneOsdModeCodeReason } from './drone-osd.ts';
export { useReportedDroneOsdModeCode } from './drone-osd.ts';
export { useReportedDroneOSD } from './drone-osd.ts';

// Unified robot hooks (moved from ros-abstraction/hooks)
export { useBattery } from './useBattery';
export type { RobotBatteryInfo } from './useBattery';
export { useLocation } from './useLocation';
export type { GpsCoordinates } from './useLocation';
export { useRobotIdentity, useIsWearable } from './useRobotIdentity';
export type { RobotIdentity } from './useRobotIdentity';
